import { render, staticRenderFns } from "./OttawaTask6Fr.vue?vue&type=template&id=9a09dca2&"
import script from "./OttawaTask6Fr.vue?vue&type=script&lang=js&"
export * from "./OttawaTask6Fr.vue?vue&type=script&lang=js&"
import style0 from "./OttawaTask6Fr.vue?vue&type=style&index=0&id=9a09dca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable,VTextField})
